import { useState } from "react";
import { Menu, X } from "lucide-react";

export const Header = ({ lang, setLang, t }) => {
  const [open, setOpen] = useState(false);

  const navItems = [
    { href: "#services", label: t.nav.services },
    { href: "#calculator", label: t.nav.calculator },
    { href: "#why", label: t.nav.whyUs },
    { href: "#contact", label: t.nav.contact },
  ];

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-40 border-b border-neutral-200/80 bg-white/75 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-2 font-display"
        >
          <span className="flex h-9 w-9 items-center justify-center bg-green-600 text-white">
            <span className="text-sm font-black tracking-tighter">CA</span>
          </span>
          <div className="leading-none">
            <div className="text-base font-black tracking-tighter text-neutral-950">
              CNG AutoCare
            </div>
            <div className="mt-0.5 text-[10px] uppercase tracking-[0.22em] text-neutral-500">
              NGV Experts · TZ
            </div>
          </div>
        </a>

        <nav className="hidden items-center gap-10 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href.replace("#", "")}`}
              className="text-sm font-medium text-neutral-700 transition-colors hover:text-green-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div
            data-testid="language-toggle"
            className="flex items-center overflow-hidden border border-neutral-300 text-xs font-semibold"
          >
            <button
              data-testid="lang-en"
              onClick={() => setLang("en")}
              className={`px-2.5 py-1.5 transition-colors ${
                lang === "en"
                  ? "bg-neutral-950 text-white"
                  : "bg-white text-neutral-700 hover:bg-neutral-100"
              }`}
            >
              EN
            </button>
            <button
              data-testid="lang-sw"
              onClick={() => setLang("sw")}
              className={`px-2.5 py-1.5 transition-colors ${
                lang === "sw"
                  ? "bg-neutral-950 text-white"
                  : "bg-white text-neutral-700 hover:bg-neutral-100"
              }`}
            >
              SW
            </button>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="flex h-9 w-9 items-center justify-center border border-neutral-300 text-neutral-800 md:hidden"
            aria-label="Menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="border-t border-neutral-200 bg-white md:hidden"
        >
          <nav className="flex flex-col px-6 py-4">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm font-medium text-neutral-800 hover:text-green-600"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};
